import { jsx as _jsx } from "react/jsx-runtime";
import { DinTestPage } from '@/pages/din-test-page.component';
import ResultCategoryPage, { ResultCategoryOutlet, } from '@/pages/result-category-page.component';
import { AgeStep, GenderStep, ConnectHeadphoneStep, HeadphoneCheckStep, PerceivedHearingStatusStep, SetupPage, VolumeStep, } from '@/pages/setup-page.component';
import { WelcomePage } from '@/pages/welcome-page.component';
import { Navigate } from 'react-router-dom';
import { SevereHearingLossResults } from '@/components/results-category/components/severe-hearing-loss-results.component';
import { MildHearingLossResults } from '@/components/results-category/components/mild-hearing-loss-results.component';
import { NormalHearingLossResults } from '@/components/results-category/components/normal-hearing-loss-results.component';
import { InstructionsStep } from '@/components/hearing-test-intructions.component';
import ScoreGraphPage from './pages/score-graph-page.component';
import { HearingAidSimulatorPage } from './pages/hearing-aid-simulator-page.component';
import { HeadphoneInformation } from './pages/headphone-information.component';
import { DisclaimerPage } from './pages/disclaimer-page';
export var appRoutes = [
    { path: '/', element: _jsx(WelcomePage, {}) },
    {
        path: '/setup',
        element: _jsx(SetupPage, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/setup/select-your-birth-year", replace: true }),
            },
            { path: 'select-your-birth-year', element: _jsx(AgeStep, {}) },
            { path: 'select-your-gender-at-birth', element: _jsx(GenderStep, {}) },
            {
                path: 'perceived-hearing-loss',
                element: _jsx(PerceivedHearingStatusStep, {}),
            },
            {
                path: 'confirm-headphone-connection',
                element: _jsx(ConnectHeadphoneStep, {}),
            },
            {
                path: 'headphone-check',
                element: _jsx(HeadphoneCheckStep, {}),
            },
            { path: 'volume', element: _jsx(VolumeStep, {}) },
        ],
    },
    { path: '/instructions', element: _jsx(InstructionsStep, {}) },
    { path: '/din-test', element: _jsx(Navigate, { to: "/din-test/1", replace: true }) },
    { path: '/din-test/:id', element: _jsx(DinTestPage, {}) },
    { path: '/score-graph', element: _jsx(ScoreGraphPage, {}) },
    {
        path: '/result-category',
        element: _jsx(ResultCategoryPage, {}),
        children: [
            {
                path: 'severe',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(SevereHearingLossResults, {}),
                    },
                ],
            },
            {
                path: 'mild',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(MildHearingLossResults, {}),
                    },
                ],
            },
            {
                path: 'normal',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(NormalHearingLossResults, {}),
                    },
                ],
            },
        ],
    },
    {
        path: '/hearing-aid-simulator',
        element: _jsx(HearingAidSimulatorPage, {}),
    },
    {
        path: '/index.html',
        element: _jsx(Navigate, { to: "/", replace: true }),
    },
    { path: 'headphone-information', element: _jsx(HeadphoneInformation, {}) },
    {
        path: '/disclaimer',
        element: _jsx(DisclaimerPage, {}),
    },
];
